import { useState,useEffect } from "react";
import axios from "axios";
import MainLayout from "../layouts/MainLayout";
import AddDesignation from "./AddDesignation";
import EditDesignation from "./EditDesignation";

function Designations(){

const [designations,setDesignations]=useState([]);
const [search,setSearch]=useState("");

const [showAddDialog,setShowAddDialog]=useState(false);

const [showEditDialog,setShowEditDialog]=useState(false);

const [selectedDesignation,setSelectedDesignation]=useState(null);

useEffect(()=>{

loadDesignations();

},[]);

const loadDesignations=async()=>{

try{

const token=
localStorage.getItem(
"token"
);

const response=
await axios.get(

"https://saleupcall.com/api/Designation/get-designations.php",

{
headers:{
Authorization:
`Bearer ${token}`
}
}

);

if(response.data.status){

setDesignations(
response.data.data
);

}

}
catch(error){

console.log(error);

}

};

const filteredDesignations=

designations.filter(

(item)=>

(item.designation_name || "")
.toLowerCase()
.includes(search.toLowerCase())

||

(item.description || "")
.toLowerCase()
.includes(search.toLowerCase())

);

const deleteDesignation=async(id)=>{

if(
!window.confirm(
"Delete this designation?"
)
){
return;
}

try{

const token=
localStorage.getItem(
"token"
);

const response=
await axios.post(

"https://saleupcall.com/api/Designation/delete-designation.php",

{
id:id
},

{
headers:{
Authorization:
`Bearer ${token}`
}
}

);

if(response.data.status){

alert(
"Designation Deleted"
);

loadDesignations();

}

}
catch(error){

console.log(error);

}

};

return(

<MainLayout>

<div className="container mt-1">

<div className="row mb-2">

<div className="col-md-4">

<h4>

Designations

</h4>

</div>

<div className="col-md-6">

<input
type="text"
className="form-control form-control-sm"
placeholder="Search Designation"
value={search}
onChange={(e)=>
setSearch(
e.target.value
)
}
/>

</div>

<div className="col-md-2">

<button
className="btn btn-success btn-sm w-100"
onClick={()=>
setShowAddDialog(
true
)
}
>

<i className="bi bi-plus-lg me-1"></i>

Add

</button>

</div>

</div>

<div className="table-responsive">

<table className="table table-bordered table-hover table-striped table-sm">

<thead className="table-success">

<tr>

<th>ID</th>
<th>Designation</th>
<th>Description</th>

<th width="150">

Actions

</th>

</tr>

</thead>

<tbody>

{

filteredDesignations.map(

(item)=>(

<tr key={item.id}>

<td>

{item.id}

</td>

<td>

{item.designation_name}

</td>

<td>

{item.description}

</td>

<td>

<button
className="btn btn-primary btn-sm me-1"
title="Edit"
onClick={()=>{

setSelectedDesignation(
item
);

setShowEditDialog(
true
);

}}
>

<i className="bi bi-pencil"></i>

</button>

<button
className="btn btn-danger btn-sm"
title="Delete"
onClick={()=>
deleteDesignation(
item.id
)
}
>

<i className="bi bi-trash"></i>

</button>

</td>

</tr>

)

)

}

</tbody>

</table>

</div>

</div>

{

showAddDialog && (

<div
className="modal d-block"
style={{
background:
"rgba(0,0,0,.5)"
}}
>

<div className="modal-dialog">

<div className="modal-content">

<div className="modal-header">

<h5>

Add Designation

</h5>

<button
className="btn-close"
onClick={()=>
setShowAddDialog(
false
)
}
>

</button>

</div>

<div className="modal-body">

<AddDesignation

onClose={()=>{

setShowAddDialog(
false
);

loadDesignations();

}}

/>

</div>

</div>

</div>

</div>

)

}

{

showEditDialog &&
selectedDesignation && (

<div
className="modal d-block"
style={{
background:
"rgba(0,0,0,.5)"
}}
>

<div className="modal-dialog">

<div className="modal-content">

<div className="modal-header">

<h5>

Edit Designation

</h5>

<button
className="btn-close"
onClick={()=>{

setShowEditDialog(
false
);

setSelectedDesignation(
null
);

}}
>

</button>

</div>

<div className="modal-body">

<EditDesignation

designation={
selectedDesignation
}

onClose={()=>{

setShowEditDialog(
false
);

setSelectedDesignation(
null
);

loadDesignations();

}}

/>

</div>

</div>

</div>

</div>

)

}

</MainLayout>

);

}

export default Designations;